import ErrorBoundary from 'components/error/ErrorBoundary'
import { useHideUnimportantErrors } from 'hooks/use-hide-unimportant-errors'
import AppRoutes from './pages/routes'
import { unused } from 'react' // Test unused import

export default function App() {
    useHideUnimportantErrors()
    return (
        <ErrorBoundary>
            <AppRoutes />
        </ErrorBoundary>
    )
}
